package top.wcpe.allincore.ui.runtime.event

/**
 * 键盘分发结果。
 *
 * [handled] 表示事件已被运行时处理器观察或处理；[consumed] 表示事件应阻止后续默认行为。
 */
data class KeyDispatchResult(val handled: Boolean, val consumed: Boolean) {
    init {
        require(!consumed || handled) { "键盘事件已消费时必须同时标记为已处理" }
    }
}
